module.exports = __webpack_public_path__ + "static/media/promosEventsBanner.1cd85d9f.webp";